const getEmbedUrl = (value) => {
  if (!value) return null;
  // If it's an iframe HTML string, extract the src attribute
  const iframeMatch = value.match(/<iframe[^>]+src=["']([^"']+)["']/i);
  if (iframeMatch) return iframeMatch[1];
  // Otherwise treat it as a plain URL
  return value;
};

const GoogleFormEmbed = ({ embededUrl }) => {
  const src = getEmbedUrl(embededUrl);

  if (!src) {
    return (
      <div style={{ width: "100%", padding: "20px", textAlign: "center", color: "#888" }}>
        No form URL configured for this module.
      </div>
    );
  }

  return (
    <div style={{ width: "100%", padding: "20px" }}>
      <iframe
        src={src}
        width="100%"
        height="800"
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
        title="Google Form"
      >
        Loading…
      </iframe>
    </div>
  );
};

export default GoogleFormEmbed;